import { IpAreaTypes, IP_AREA_JP_ID } from '../Constants';
var IpAreaSettingFormModel = /** @class */ (function () {
    function IpAreaSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, ipAreaType = _a.ipAreaType, ipAreaIds = _a.ipAreaIds;
        this.ipAreaType = ipAreaType || IpAreaTypes.COUNTRY;
        this.ipAreaIds = ipAreaIds || [IP_AREA_JP_ID];
    }
    Object.defineProperty(IpAreaSettingFormModel.prototype, "emptyViolation", {
        get: function () {
            var _a;
            return ((_a = this.ipAreaIds) === null || _a === void 0 ? void 0 : _a.length) === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IpAreaSettingFormModel.prototype, "isValid", {
        get: function () {
            return !this.emptyViolation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IpAreaSettingFormModel.prototype, "isIpAreaWholeCountry", {
        get: function () {
            return this.ipAreaType === IpAreaTypes.COUNTRY;
        },
        enumerable: false,
        configurable: true
    });
    IpAreaSettingFormModel.prototype.changeIpAreaType = function (type) {
        this.ipAreaType = type;
        if (type === IpAreaTypes.COUNTRY) {
            // 日本のid を ipAreaIds にする
            this.ipAreaIds = [IP_AREA_JP_ID];
        }
        else if (type === IpAreaTypes.REGION) {
            this.ipAreaIds = [];
        }
    };
    return IpAreaSettingFormModel;
}());
export { IpAreaSettingFormModel };
